import { onMounted, onUnmounted, ref } from 'vue';

export function useReducedMotion() {
  const prefersReducedMotion = ref(false);

  const updateMedia = (e) => {
    prefersReducedMotion.value = e.matches;
  };

  let mediaQuery;

  onMounted(() => {
    mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    prefersReducedMotion.value = mediaQuery.matches;

    mediaQuery.addEventListener('change', updateMedia);
  });

  onUnmounted(() => {
    mediaQuery.removeEventListener('change', updateMedia);
  });

  return { prefersReducedMotion };
}
